var _defs, _rect, _g, _g2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgenticai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f1220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1b1330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "node",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,164)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(166,104,255)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#node)",
    strokeWidth: 2,
    opacity: 0.55,
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 150,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 150,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 650,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 650,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 120,
    x2: 150,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 120,
    x2: 650,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 120,
    x2: 400,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 120,
    x2: 400,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 380,
    x2: 400,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 380,
    x2: 400,
    y2: 440
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#node)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 250,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 120,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 380,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 120,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 380,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 60,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 440,
    r: 10
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 257,
    textAnchor: "middle",
    fontFamily: "Consolas, monospace",
    fontSize: 20,
    fill: "#0f1220",
    fontWeight: 700
  }, "AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 480,
    textAnchor: "middle",
    fontFamily: "Consolas, monospace",
    fontSize: 24,
    fill: "rgb(0,255,164)",
    opacity: 0.9
  }, "agentic_ai_workflows")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenticai);
export default __webpack_public_path__ + "static/media/agenticai.8c80e4511f1a19419cafe12e1a917abb.svg";
export { ForwardRef as ReactComponent };